<template>
 <div class="o-my-orders">

    <app-navigation :currentSpace="$t('web.my_orders.nav_space')"></app-navigation>

    <main class="o-my-orders__main">

      <section class="c-page-header">
        <div class="c-page-header__left">
          <h1 class="c-page-header__left__title">{{ $t('web.my_orders.page_header') }}</h1>
        </div>
      </section>

      <section class="c-card c-card--orders">
        <div class="c-card__header">
          <h2 class="c-card__title t-headline">{{ $t('web.my_orders.card_header') }}</h2>
        </div>
        <div class="c-card--orders__body">
          <order-list v-if="orders.orders.length > 0" :orders="orders" :fetchOrderCallback="fetchOrders"></order-list>
        </div>
      </section>

    </main>

    <app-footer></app-footer>

  </div>
</template>

<script>
import API from '@/services'
import OrderList from '@/views/components/catalog/OrderList'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'my-orders',
  components: {
    'order-list': OrderList
  },
  data () {
    return {
      orders: {
        orders: [],
        pagination: null
      }
    }
  },
  mounted () {
    this.LOAD_PARTICIPANT(this.$router)
    this.fetchOrders(1)
  },
  methods: {
    fetchOrders: function (whichPage) {
      return API.getAuthenticated('/rewards/order/list/' + whichPage)
        .then(resp => {
          this.orders.orders = resp.data.orders.data
          this.orders.pagination = resp.data.pagination
          return Promise.resolve()
        })
        .catch(err => {
          return Promise.reject(err)
        })
    },
    ...mapActions([
      'LOAD_PARTICIPANT'
    ])
  },
  computed: {
    ...mapGetters([
    ])
  }
}

</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// MyOrders.vue?1c915602